import React, { useState, useEffect } from "react";
import { Button } from "reactstrap";
//Redux
import { connect } from "react-redux";

//API Calls
import { functionsHttpsCallable } from "../../../utils/FirebaseStorage/firebase";

const estadoEmpresa = functionsHttpsCallable("ape_getEstadoEmpresa");
const setEstadoEmpresa = functionsHttpsCallable("ape_setEstadoCargueContratos");

const mapStateToProps = (state) => ({
  usuarioActivo: state,
});

let BodyHabilitarCargaContrato = (props) => {
  const [estado, setEstado] = useState(false);
  const [userData] = useState(JSON.parse(localStorage.getItem("userData")));

  useEffect(() => {
    const getEstado = async () => {
      props.toggleLoading();
      try {
        const reqEstado = await estadoEmpresa({
          cod_empr: userData.codigoEmpresa,
        });
        console.log("reqEstado", reqEstado.data.data.cargueContratoHabilitado);
        setEstado(reqEstado.data.data.cargueContratoHabilitado);
        props.toggleLoading();
        props.toastSuccess("Estado obtenido con éxito");
      } catch (error) {
        props.toggleLoading();
        props.toastError("Error al obtener estado");
        console.log(error);
      }
    };
    getEstado();
  }, []);

  const cambioEstado = async () => {
    try {
      props.toggleLoading();
      const request = await setEstadoEmpresa({
        cod_empr: userData.codigoEmpresa,
        estado: !estado,
      });
      setEstado(!estado);
      props.toastSuccess("Cambio de estado exitoso!");
      props.toggleLoading();
      props.toggle();
    } catch (error) {
      props.toggleLoading();
      console.log(error);
      props.toastError("Error con el cambio de estado");
    }
  };

  return (
    <div className="div-estado-carga-contrato">
      Actualmente el estado es{" "}
      <strong>{estado ? "Habilitado" : "Deshabilitado"}</strong>
      <br />
      <div>
        <Button
          color={estado ? "danger" : "success"}
          onClick={() => {
            cambioEstado();
          }}
        >
          {estado ? "Deshabilitar" : "Habilitar"}
        </Button>
      </div>
    </div>
  );
};
export default connect(mapStateToProps)(BodyHabilitarCargaContrato);
